/** 品質保証対象（層 C）の公式対応言語。 */
export const COMMO_SUPPORTED_LANGUAGES = [
  'en',
  'ja',
  'es',
  'de',
  'fr',
  'pt-BR',
  'it',
  'nl',
  'pl',
  'tr',
  'zh-CN',
  'ko',
  'id',
  'vi',
  'cs',
  'uk',
  'ru',
] as const;

export type CommoLanguage = (typeof COMMO_SUPPORTED_LANGUAGES)[number];

export const COMMO_DEFAULT_LANGUAGE: CommoLanguage = 'en';

/** ピッカー表示用（ネイティブ名）。 */
export const COMMO_LANGUAGE_NATIVE_NAMES: Record<CommoLanguage, string> = {
  en: 'English',
  ja: '日本語',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  'pt-BR': 'Português (Brasil)',
  it: 'Italiano',
  nl: 'Nederlands',
  pl: 'Polski',
  tr: 'Türkçe',
  'zh-CN': '简体中文',
  ko: '한국어',
  id: 'Bahasa Indonesia',
  vi: 'Tiếng Việt',
  cs: 'Čeština',
  uk: 'Українська',
  ru: 'Русский',
};

export function isCommoLanguage(
  value: string | null | undefined,
): value is CommoLanguage {
  return (
    typeof value === 'string' &&
    (COMMO_SUPPORTED_LANGUAGES as readonly string[]).includes(value)
  );
}
